import get from 'lodash/get';

export const arrayToObject = (array) => {
  const formatted = {};
  if (array && array.length) {
    array.forEach((item) => {
      formatted[item.id] = item;
    });
  }
  return formatted;
};

export const removeByKey = (initialObject, deleteKey) =>
  Object.keys(initialObject)
    .filter((key) => Number(key) !== Number(deleteKey))
    .reduce(
      (resultObject, currentKey) => ({
        ...resultObject,
        [currentKey]: initialObject[currentKey],
      }),
      {},
    );

export const mergeObjects = (objA, objB) => {
  const newObj = { ...objA };
  // const peopleObject = arrayToObject(action.payload.data);
  Object.keys(objB).forEach((key) => {
    const currentVal = get(newObj, key, {}) || {};
    newObj[key] = Object.assign(currentVal, objB[key]);
  });
  return newObj;
};
